import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { thousandsFormatter } from 'aem-libs-react-ts/src/utils/Formatters'

import cs from './i18n/cs.json'
import en from './i18n/en.json'

interface ITargetAmountProps {
  amount: number
  children: ReactNode
  rf?: string
}

const TargetAmountResult = ({ rf, amount, children }: ITargetAmountProps) => {
  const { t, i18n } = useTranslation()
  i18n.addResourceBundle('cs', 'TargetAmountResult', cs)
  i18n.addResourceBundle('en', 'TargetAmountResult', en)

  return (
    <div className='csas-result'>
      <div className='csas-result-inner'>
        <div className='csas-result-inner-left'>{children}</div>
        <div className='csas-result-inner-right'>
          <strong className='csas-strong-medium'>
            <span data-rf={rf}>{`${thousandsFormatter(amount)} ${t(
              'CZK',
            )}`}</span>
          </strong>
        </div>
      </div>
    </div>
  )
}

export { TargetAmountResult }
